import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-booking-detail",
  templateUrl: "./booking-detail.component.html",
  styleUrls: ["./booking-detail.component.scss"],
})
export class BookingDetailComponent implements OnInit {
  // isInquiry: boolean = false;

  @Input() bookingData;
  @Input() flexData;
  @Input() showVideoConf;
  @Input() isMemberVisible;
  @Input() isCategoryVisible;
  @Input() isInquiry;

  flexFields = null;
  data = {
    personnel: "",
    date: "",
    time: "",
    name: "",
    phone: "",
    email: "",
    isVideoConf: "No",
  };

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.bookingData) {
      this.data = this.bookingData;
    }

    if (this.showVideoConf == false) {
      delete this.data.isVideoConf;
    }

    // if (this.flexData) {
    //   this.flexFields = JSON.parse(JSON.stringify(this.flexData));
    //   this.flexFields.forEach((element: any) => {
    //     if (element.input_type == "Toggle") {
    //       if (!element.value || element.value == "false") {
    //         element.value = "No";
    //       } else {
    //         element.value = "Yes";
    //       }
    //     } else {
    //       if (!element.value) {
    //         element.value = "-";
    //       }
    //     }
    //   });
    // }
  }

  public show12HrTime(time) {
    if (!time) {
      return "-";
    }
    return this.commonService.format12HourTime(time);
  }
}
